//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
export default {
  name: "PersonalData",
  props: {},
  methods: {
    ...mapActions(["setUserSettings", "updateUserName", "changeUserEmail", "updatePassword"]),
  },
  computed: {
    ...mapGetters(["getUser", "getTokenExpireInMs"]),

    // https://vuejs.org/v2/guide/computed.html
    user: {
      get() {
        if (this.$store.getters.getUser) {
          return this.$store.getters.getUser.clone();
        } else {
          return null;
        }
      },
      set() {
        // all other values will be saved via the @save event
      },
    },
  },
  data() {
    return {
      newPassword: "",
      oldPassword: "",
      showChangePass: false,
    };
  },
};
